import React from 'react';
export function Header() {
  return <header className="w-full py-12 md:py-16 flex justify-center items-center px-4 animate-in fade-in duration-1000" data-id="element-33">
      <div className="relative w-full max-w-[600px]" data-id="element-34">
        <img src="https://cdn.magicpatterns.com/uploads/qmwBa2tP2vciePEfbWYRRk/top_notch_logga.png" alt="Top Notch Bakery Logo" className="w-full h-auto object-contain drop-shadow-sm" data-id="element-35" />
      </div>
    </header>;
}